import React from "react";
import ReactDOM from "react-dom/client";

import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-notifications-component/dist/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";

import "./index.scss";
import App from "./App";
import store from "./store";
import featureFlags from "./featureFlags.json"
import { theme } from "./theme/theme";
import { FlagsProvider } from 'react-feature-flags';
import ErrorBoundary from "./components/ErrorBoundary";
import { disableConsoleInProduction } from "./utils/disableConsole";
import { ThemeProvider as CustomThemeProvider } from "./context/ThemeContext";
import ThemeWrapper from "./components/ThemeWrapper";

// Disable all console logs in production
disableConsoleInProduction();

// Environment test removed for production

function updateHeadElements() {
    let sikiEnv = process.env.REACT_APP_SIKI_ENV;
    let sikiVersion = process.env.REACT_APP_SIKI_VERSION;
    let bannerText = "SIKI";
    if ( sikiEnv && sikiEnv !== "prod" ) bannerText += " - " + sikiEnv;
    if ( sikiVersion ) bannerText += " - " + sikiVersion;

    // Banner text logged to console - removed for production

    document.title = bannerText;

    const metaVersion = document.querySelector('meta[name="version"]');
    if ( metaVersion ) metaVersion.setAttribute("content", sikiVersion );
}
updateHeadElements();

// App render log removed for production
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <FlagsProvider value={featureFlags}>
      <CustomThemeProvider>
        <ThemeWrapper>
          <Provider store={store}>
            <App />
            <ToastContainer />
          </Provider>
        </ThemeWrapper>
      </CustomThemeProvider>
    </FlagsProvider>
  </ErrorBoundary>
);